import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Layout } from "../layout/Layout";
import { useForgotPassword } from "../hooks/control";

export default function ForgotPassword() {
	const { forgotPassword } = useForgotPassword();

	const [email, setEmail] = useState("");
	const [error, setError] = useState<string | null>(null);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [submitted, setSubmitted] = useState(false);

	const normalizedEmail = useMemo(() => email.trim().toLowerCase(), [email]);

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setError(null);

		if (!normalizedEmail) {
			setError("Ingresa tu correo electrónico.");
			return;
		}

		setIsSubmitting(true);
		try {
			await forgotPassword(normalizedEmail);
			setSubmitted(true);
		} catch (err) {
			const msg =
				err instanceof Error
					? err.message
					: "No se pudo procesar la solicitud. Intenta de nuevo.";
			setError(msg);
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<Layout>
			<div className='bg-white px-4 py-10'>
				<div className='mx-auto flex min-h-[calc(100vh-120px)] w-full items-center justify-center'>
					<div className='w-full max-w-md rounded-2xl bg-white px-10 py-10 shadow-[0_16px_40px_rgba(15,23,42,0.12)]'>
						<h1 className='text-center text-xl font-medium text-slate-700'>
							Recuperar contraseña
						</h1>
						<p className='mt-3 text-center text-sm text-slate-500'>
							Te enviaremos un enlace para restablecer tu contraseña.
						</p>

						{submitted ? (
							<div className='mt-6 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800'>
								Si el email existe, te enviamos instrucciones.
							</div>
						) : (
							<form onSubmit={handleSubmit} className='mt-6 space-y-4'>
								{error ? (
									<div className='rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700'>
										{error}
									</div>
								) : null}

								<div className='space-y-2'>
									<label className='block text-xs font-medium text-slate-500'>
										Correo electrónico
									</label>
									<input
										type='email'
										value={email}
										onChange={(event) => setEmail(event.target.value)}
										placeholder='tu@correo.com'
										autoComplete='email'
										required
										className='w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-primary focus:ring-2 focus:ring-secondary'
									/>
								</div>

								<button
									type='submit'
									disabled={isSubmitting}
									className='w-full cursor-pointer rounded-full bg-primary py-2.5 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-60'
								>
									{isSubmitting ? "Enviando..." : "Enviar instrucciones"}
								</button>
							</form>
						)}

						<div className='mt-6 text-center text-xs text-slate-500'>
							<Link
								to='/login'
								className='text-primary hover:text-primary-hover'
							>
								Volver a iniciar sesión
							</Link>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	);
}
